import { request } from '@/shared/api/request'

export const saveXMLEmployee = ({ data, params }) => {
	return request({
		method: 'POST',
		url: 'staff/edit/xml/',
		data,
		params
	})
}
